if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList);
            for (let item of MutationList) {
                if (item.target.localName === "quick-buy-drawer") {
                    document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                }
                if (item.target.localName === "cart-drawer") {
                    setTimeout(() => {
                        addBssCartTotalPriceAttribute()
                    }, 1000)
                }
                if (item.target.classList.contains('predictive-search__results')) {
                    handleCartDrawerFooterMutation()
                }
                if (item.target.classList.contains('header__cart-count')) {
                    setTimeout(() => {
                        addBssCartTotalPriceAttribute();
                        handleCartDrawerFooterMutation();
                    }, 1000)                    
                }                                   
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    setTimeout(() => {
        addBssCartTotalPriceAttribute();
    }, 3000)

    setTimeout(() => {
        handleCartDrawerFooterMutation();
    }, 3000)

function addBssCartTotalPriceAttribute() {
    const allElements = document.querySelectorAll(".docapp-with-shipping .docapp-right");
    let updated = false;

    allElements.forEach(element => {
        const sibling = element.parentElement.querySelector(".docapp-free-shipping-price");

        if (sibling) return;

        if (!element.hasAttribute("bss-b2b-cart-total-price")) {
            element.setAttribute("bss-b2b-cart-total-price", "");
            updated = true;
        }
    });

    if (updated) {
        BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
    }
}


    async function handleCartDrawerFooterMutation() {
        if (BSS_B2B) {
            const res = await BSS_B2B.storage.productStorage.load();
            if (res) {
                if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                    BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                        ...res
                    });
                }
            }
        }
    }
}